import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { WorkflowStep } from "../../model/workflow/workflow-step.model";
import { createUrl } from "../api.util";
import { GenericApi } from "../generic.api";

// Convenience Type
type T = WorkflowStep;

@Injectable({
  providedIn: "root",
})
export class WorkflowStepApi extends GenericApi<T> {
  public path = "workflow-step";

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  readonly getForDropdown = (): Observable<T[]> => {
    return this.httpClient.get<T[]>(createUrl(this.path, "get-all"), {});
  };
}
